var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.149 40.9615L13.6146 41.6562L14.3094 35.1219C14.4469 34.0312 14.9271 32.9792 15.7605 32.1448C17.7719 30.1333 21.0521 30.151 23.0865 32.1844C25.1209 34.2177 25.1386 37.4979 23.1261 39.5104C22.2917 40.3448 21.2396 40.824 20.149 40.9615Z",
    fill: "#7DEBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4865 28.5177L35.4845 38.9323L27.1511 47.2708L27.4188 37.5229L35.4865 28.5177Z",
    fill: "#329F4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7531 19.7844L16.3385 19.7865L8 28.1198L17.7479 27.8521L26.7531 19.7844Z",
    fill: "#329F4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7198 9.23958L14.9427 30.0167L25.2542 40.3281L46.0313 19.551L47.2709 8L35.7198 9.23958Z",
    fill: "#7CCC90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4751 31.5489L23.722 38.7958C25.1095 36.7844 24.8949 33.9927 23.0866 32.1844C21.2782 30.376 18.4866 30.1625 16.4751 31.5489Z",
    fill: "#329F4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7761 20.6197C39.502 20.6197 40.9011 19.2206 40.9011 17.4948C40.9011 15.7689 39.502 14.3698 37.7761 14.3698C36.0502 14.3698 34.6511 15.7689 34.6511 17.4948C34.6511 19.2206 36.0502 20.6197 37.7761 20.6197Z",
    fill: "#329F4C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4104 27.9855C32.1363 27.9855 33.5354 26.5864 33.5354 24.8605C33.5354 23.1346 32.1363 21.7355 30.4104 21.7355C28.6845 21.7355 27.2854 23.1346 27.2854 24.8605C27.2854 26.5864 28.6845 27.9855 30.4104 27.9855Z",
    fill: "#329F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.d14768b433f53e812409877822a3c8aa.svg";
export { ForwardRef as ReactComponent };